import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { StateWithSpinnerMessages } from '../store/spinnerMessagesSlice';

export const useAppWithSpinnerMessagesSelector: TypedUseSelectorHook<StateWithSpinnerMessages> = useSelector;
